import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '更新快讯', href: '#updates' },
  { label: '热门连载', href: '#cards' },
  { label: '联系我们', href: '#contact' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-[60px] flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 no-underline group">
          <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </div>
          <span className="font-heading text-xl text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
            妖精漫画网
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-full transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-200 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-foreground-800 text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block py-3 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-100 last:border-0 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}